if (!customElements.get('frame-details-drawer')) {
  customElements.define(
    'frame-details-drawer',
    class FrameDetailsDrawer extends HTMLElement {
      constructor() {
        super();

        this.sectionId = this.dataset.sectionId;
        this.triggerSelector = `[data-frame-details-trigger="${this.sectionId}"]`;

        this.onBodyClick = this.handleBodyClick.bind(this);
        this.onKeyup = this.handleKeyup.bind(this);
        this.onTriggerClick = this.handleTriggerClick.bind(this);

        this.closeButton = this.querySelector('.frame-details-drawer__header__button');
        if (this.closeButton) {
          this.closeButton.addEventListener('click', () => this.hide());
        }

        this.addEventListener('keyup', this.onKeyup);

        this.relocate();
        this.bindTrigger();
      }

      relocate() {
        if (this.parentElement !== document.body) {
          document.body.appendChild(this);
        }
      }

      bindTrigger() {
        const trigger = document.querySelector(this.triggerSelector);
        if (!trigger || trigger.dataset.frameDetailsBound === 'true') return;
        trigger.dataset.frameDetailsBound = 'true';
        trigger.addEventListener('click', this.onTriggerClick);
      }

      handleTriggerClick(event) {
        this.show(event.currentTarget);
      }

      handleKeyup(event) {
        if (event.code && event.code.toUpperCase() === 'ESCAPE') this.hide();
      }

      handleBodyClick(event) {
        const target = event.target;
        if (
          target !== this &&
          !target.closest('frame-details-drawer') &&
          !target.closest(this.triggerSelector)
        ) {
          this.hide();
        }
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        if (typeof trapFocus === 'function') trapFocus(this);
      }

      hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        if (typeof removeTrapFocus === 'function') removeTrapFocus(this.focusElement);
      }
    }
  );
}
